import { render, staticRenderFns } from "./SalesContractOverview.vue?vue&type=template&id=b20bdf66&scoped=true"
import script from "./SalesContractOverview.vue?vue&type=script&lang=js"
export * from "./SalesContractOverview.vue?vue&type=script&lang=js"
import style0 from "./SalesContractOverview.vue?vue&type=style&index=0&id=b20bdf66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b20bdf66",
  null
  
)

export default component.exports